export const PreviewHeader = () => {
    return (
        <div className="absolute top-0 left-0 w-full z-[-1] max-h-[270px] overflow-hidden">
            <img src="/images/preview-bg.jpg" alt="Preview" className="object-cover object-center w-full" />
        </div>
    );
};
